var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-nav-content",attrs:{"id":"help"}},[_c('navigation',{attrs:{"permanent":_vm.$vuetify.breakpoint.mdAndUp}}),_c('help-text',{staticClass:"mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }